import { render, staticRenderFns } from "./NothingFound.vue?vue&type=template&id=57238734&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57238734')) {
      api.createRecord('57238734', component.options)
    } else {
      api.reload('57238734', component.options)
    }
    module.hot.accept("./NothingFound.vue?vue&type=template&id=57238734&", function () {
      api.rerender('57238734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/PartnerAnalysesPage/components/NothingFound.vue"
export default component.exports